export default __webpack_public_path__ + "static/media/Mark-2-HUD-Pop-Up (3 Layers).55fdd9cd.jpg";